import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedCallback, useDisclosure } from "@mantine/hooks";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBuildingWarehouse,
  IconCaretDown,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getMasterOrgSelect } from "../../../service/getSelectApi";

const InventoryDocuments = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<InventoryItem[]>([]);
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
  const [dataBranch, setDataBranch] = useState<SelectListItemModel[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [search, setSearch] = useState({
    keySearch: "",
    branchCode: [],
    invCode: [],
    itemCode: [],
    fromDate: "",
    toDate: "",
  });

  type InventoryItem = {
    branchCode: string;
    branchName: string;
    countSoLuong: number;
    dvt: string | null;
    idBranch: number;
    idKho: number;
    maKho: string;
    maSp: string;
    soLuong: number | null;
    tenKho: string;
    tenSp: string;
  };

  const handleChangeSearchValue = (value: string[] | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : [],
    }));
  };
  const handleChangeSearch = (value: string | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : 0,
    }));
  };

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };
  const handleCheckView = async (row: any) => {
    if (row.original.orderHeaderType == "3") {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.soCt}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        navigate("/sell/view-return-order", {
          state: {
            id: row.original.id,
            orderNumber: row.original.soCt,
            orderType: row.original.orderHeaderType,
            actionType: "view",
          },
        });
      }
    } else {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.soCt}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        navigate("/sell/view-order", {
          state: {
            id: row.original.id,
            orderNumber: row.original.soCt,
            orderType: row.original.orderHeaderType,
            actionType: "view",
          },
        });
      }
    }
  };
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "soCt",
        header: "Số chứng từ",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Tooltip label="Xem chi tiết">
              <Badge
                variant="dot"
                radius="xs"
                onDoubleClick={() => handleCheckView(row)}
                style={{
                  cursor: "pointer",
                }}
                size="lg"
                color={renderedCellValue === null ? "red" : green.base}
              >
                {renderedCellValue}
              </Badge>
            </Tooltip>
          </>
        ),
      },
      {
        accessorKey: "loaiCt",
        header: "Loại chứng từ",
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge size="sm" color="cyan">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "cn",
        header: "Chi nhánh",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge variant="light" color="violet">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "subInvCode",
        header: "Mã Kho",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge variant="light" color="blue">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge variant="light" color="blue">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "tenNhanVien",
        header: "Tên nhân viên",
      },
      {
        accessorKey: "ngayTao",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ngayHoanThanh",
        header: "Ngày hoàn thành",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "trangThaiCt",
        header: "Trạng thái chứng từ",
        Cell: ({ renderedCellValue }: { renderedCellValue: any }) => (
          <>
            <Badge size="sm" variant="light" color="green">
              {renderedCellValue === "DON_HANG_HOAN_THANH"
                ? "Đơn hàng hoàn thành"
                : renderedCellValue?.replace(/_/g, " ")}{" "}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "trangThaiTongHop",
        header: "Trạng thái tổng hợp",
        Cell: ({ renderedCellValue }: { renderedCellValue: any }) => (
          <>
            <Badge size="sm" variant="light" color="green">
              {renderedCellValue === "DON_HANG_HOAN_THANH"
                ? "Đơn hàng hoàn thành"
                : renderedCellValue?.replace(/_/g, " ")}{" "}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "amountTotal",
        header: "Tổng số tiền",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? ""
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
      },
      {
        accessorKey: "amountPaid",
        header: "Số tiền đã trả",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? renderedCellValue
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
      },
      {
        accessorKey: "amountRemaining",
        header: "Số tiền còn lại",
        Cell: ({ renderedCellValue }: any) => (
          <>
            {formatCurrencyVND(renderedCellValue) == 0
              ? renderedCellValue
              : formatCurrencyVND(renderedCellValue)}
          </>
        ),
      },

      {
        accessorKey: "slTon",
        header: "Số lượng tồn",
      },
      {
        accessorKey: "slChoXuat",
        header: "Số lượng chờ xuất",
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
      },
    ],
    [],
  );

  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );

  // Sử dụng debounce để trì hoãn việc gọi API
  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    if (value.length >= 3) {
      DataItemCode(value); // Gọi API với từ khóa tìm kiếm
    }
  }, 500);

  const exportDataExcel = async () => {
    if (
      (!search.branchCode || search.branchCode?.length === 0) &&
      (!search.itemCode || search.itemCode?.length === 0) &&
      (!search.keySearch || search.keySearch?.length < 3)
    ) {
      NotificationExtension.Fails(
        "Vui lòng chọn ít nhất 1 chi nhánh, 1 mã sản phẩm hoặc nhập ít nhất 3 từ khóa tìm kiếm trước khi export excel !",
      );
    } else {
      open();
      try {
        let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

        if (search.branchCode && search.branchCode.length > 0) {
          search.branchCode.forEach((branchCode) => {
            url += `&BranchCodes=${branchCode}`;
          });
        }
        if (search.fromDate) {
          url += `&FromDate=${search.fromDate}`;
        }
        if (search.toDate) {
          url += `&ToDate=${search.toDate}`;
        }
        if (search.invCode && search.invCode.length > 0) {
          search.invCode.forEach((invCode) => {
            url += `&InvCodes=${invCode}`;
          });
        }
        if (search.itemCode && search.itemCode.length > 0) {
          search.itemCode.forEach((itemCode) => {
            url += `&ItemCodes=${itemCode}`;
          });
        }
        if (search.keySearch) {
          url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
        }
        const baseUrl = `/api/v1/ExportExcel/export-item-Reserver-Report${url}`;

        const _url = BASE_API_DELIVERY + baseUrl;
        const token = localStorage.getItem("token");

        const response = await fetch(_url, {
          method: "GET",
          headers: {
            "Content-Type": "application/vnd.ms-excel",
            Authorization: `Bearer ${token
              ?.replace(`"`, "")
              ?.replace(`"`, "")}`,
          },
        });

        if (!response.ok) {
          NotificationExtension.Fails("Export Excel thất bại !");
        } else {
          const blob = await response.blob();
          const urlss = window.URL.createObjectURL(blob);
          const _name = new Date().toISOString().slice(0, 10);
          let filename = "bao_cao_liet_ke_chung_tu_giu_hang.xlsx";
          const link = document.createElement("a");
          link.href = urlss;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          close();
          NotificationExtension.Success("Export Excel thành công !");
        }
      } catch (error) {
        console.log(error);
      } finally {
        close();
      }
    }
  };

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    if (
      (!search.branchCode || search.branchCode?.length === 0) &&
      (!search.itemCode || search.itemCode?.length === 0) &&
      (!search.keySearch || search.keySearch?.length < 3)
    ) {
      NotificationExtension.Fails(
        "Vui lòng chọn ít nhất 1 chi nhánh, 1 mã sản phẩm hoặc nhập ít nhất 3 từ khóa tìm kiếm !",
      );
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);

      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;
      if (search.branchCode && search.branchCode.length > 0) {
        search.branchCode.forEach((branchCode) => {
          url += `&BranchCodes=${branchCode}`;
        });
      }
      if (search.fromDate) {
        url += `&FromDate=${search.fromDate}`;
      }
      if (search.toDate) {
        url += `&ToDate=${search.toDate}`;
      }
      if (search.invCode && search.invCode.length > 0) {
        search.invCode.forEach((invCode) => {
          url += `&InvCodes=${invCode}`;
        });
      }
      if (search.itemCode && search.itemCode.length > 0) {
        search.itemCode.forEach((itemCode) => {
          url += `&ItemCodes=${itemCode}`;
        });
      }
      if (search.keySearch) {
        url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      try {
        const response = await repositoryDelivery.get(
          `/api/v1/ItemReserverReport/get-list${url}`,
        );
        if (response && response.success) {
          let result = response.data;
          setData(result);
          setRowCount(response.totalCount);
          setIsCallFirst(true);
          table.resetRowSelection();
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
      }
    }
  };

  const DataInvCode = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-all?select=true",
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.text && item.att1)
        ?.map((item: any) => ({
          label: String(item.text),
          value: String(item.att1),
        }));
      setDataInvCode(data);
    }
  };

  const DataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.att1)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.att1),
        }));
      setDataBranch(data);
    }
  };

  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      // const response = await repositoryDelivery.get(
      //   `api/v1/TblInventorySerialOnhand/get-list-item-by-inv?Skip=0&Take=50` +
      //     url
      // );
      const response = await repositoryPos.get(
        `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`,
      );
      if (response && response.success) {
        // const transformedData = response.data
        //   ?.filter((i: any) => i.maSp && i.tenSp)
        //   .map((branch: any) => ({
        //     value: branch.maSp,
        //     label: branch.maSp + " - " + branch.tenSp,
        //   }));
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    DataBranch();
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "soCt"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.departmentId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    enableTopToolbar: false,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <div ref={headerRef} style={{ width: "100%", marginBottom: "10px" }}>
        <Flex justify={"space-between"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Flex>
        <Grid w={"100%"}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Input
              placeholder="Nhập tìm kiếm"
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearch(e.target.value ?? "", "keySearch");
              }}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={search.fromDate ? new Date(search.fromDate) : null}
              onChange={(e) => {
                setSearch((prevData) => ({
                  ...prevData,
                  fromDate: formatDateNotTimeZone(e),
                }));
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={search.toDate ? new Date(search.toDate) : null}
              onChange={(e) => {
                setSearch((prevData) => ({
                  ...prevData,
                  toDate: formatDateNotTimeZone(e),
                }));
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              size="sm"
              placeholder="Chi nhánh"
              searchable
              clearable
              data={dataBranch}
              value={search.branchCode}
              leftSection={<IconBrandBootstrap size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value, "branchCode");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              size="sm"
              placeholder="Mã kho"
              searchable
              clearable
              data={dataInvCode}
              value={search.invCode}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              onClick={() => {
                if (dataInvCode.length === 0) {
                  DataInvCode();
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "invCode");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              size="sm"
              placeholder="Mã sản phẩm"
              clearable
              searchable
              data={dataItemCode.map((x) => x.value)} // Hiển thị kết quả từ API
              value={search.itemCode}
              renderOption={renderMultiSelectOption}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              onSearchChange={(value) => {
                // if (value.length >= 3) {
                //   DataItemCode(value); // Gọi API với từ khóa tìm kiếm
                // }
                debouncedDataItemCode(value);
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "itemCode");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1 }}>
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <MantineReactTable table={table} />
    </Box>
  );
};

export default InventoryDocuments;
